// components/ui/Select.jsx - Shadcn style Select
import React, { forwardRef } from 'react';

const Select = forwardRef(({ 
  options = [],
  value,
  onChange,
  placeholder = 'Select an option',
  className = '',
  error = false,
  disabled = false,
  label,
  helperText,
  required = false,
  ...props 
}, ref) => {
  const baseClasses = 'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50';
  
  const errorClasses = error ? 'border-destructive focus:ring-destructive' : '';
  
  const selectClasses = `${baseClasses} ${errorClasses} ${className}`?.trim()?.replace(/\s+/g, ' ');

  const selectElement = (
    <select
      ref={ref}
      value={value}
      onChange={onChange}
      className={selectClasses}
      disabled={disabled}
      required={required}
      {...props}
    >
      {placeholder && (
        <option value="" disabled>
          {placeholder}
        </option>
      )}
      {options?.map((option) => {
        // Handle both string arrays and object arrays
        if (typeof option === 'string') {
          return (
            <option key={option} value={option}>
              {option}
            </option>
          );
        }
        
        // Assume object with value and label properties
        return (
          <option key={option?.value} value={option?.value}>
            {option?.label || option?.name || option?.value}
          </option>
        );
      })}
    </select>
  );

  if (label || helperText) {
    return (
      <div className="space-y-2">
        {label && (
          <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
            {label}
            {required && <span className="text-destructive ml-1">*</span>}
          </label>
        )}
        {selectElement}
        {helperText && (
          <p className={`text-sm ${error ? 'text-destructive' : 'text-muted-foreground'}`}>
            {helperText}
          </p>
        )}
      </div>
    );
  }

  return selectElement;
});

Select.displayName = 'Select';

export default Select;